module.exports = __webpack_public_path__ + "static/media/48389784_2308754505866394_6760367416842125312_o.ab880c85.jpg";